import { render, staticRenderFns } from "./person_list.vue?vue&type=template&id=095cface&scoped=true"
import script from "./person_list.vue?vue&type=script&lang=js"
export * from "./person_list.vue?vue&type=script&lang=js"
import style0 from "./person_list.vue?vue&type=style&index=0&id=095cface&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095cface",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('095cface')) {
      api.createRecord('095cface', component.options)
    } else {
      api.reload('095cface', component.options)
    }
    module.hot.accept("./person_list.vue?vue&type=template&id=095cface&scoped=true", function () {
      api.rerender('095cface', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/process/components/process_approve/person_list.vue"
export default component.exports